import React from "react";
import { Card, CardContent, Grid } from "@mui/material";
import { ErrorMessage, LoadingSpinner } from "src/components/common";
import { useAddonsItems } from "src/hooks/ManageWorkOrder";
import type { AddonsItems } from "src/types/manageWorkOrder";
import AddonsCard from "./AddonsCard";

type AddonsListingProps = {
  workOrderId: number;
};

type AddonsItemsResults = {
  data: AddonsItems[];
  isLoading: boolean;
  error: string | null;
};

export type CellProps = {
  title: string | number;
  align?: any;
};

function AddonsListing({
  workOrderId,
}: AddonsListingProps) {

  const {
    data: AddonsItems,
    isLoading,
    error,
  } = useAddonsItems(workOrderId) as AddonsItemsResults;
  return (
    <Card sx={{padding: '0px 16px 0px 16px', boxShadow: 'none'}}>
      <CardContent
        sx={{
          overflowY: "auto",
          maxHeight: "430px",
          padding: '0px !important',
        }}
      >
        {isLoading ? (
          <LoadingSpinner height="37vh" width="20vh" />
        ) : error ? (
          <ErrorMessage message={`${error}`} />
        ) : (
          <Grid container rowGap={2}>
            {AddonsItems?.map((row) => (
              <Grid item xs={12} key={row.Id} px={1}>
                <AddonsCard
                  data={row}
                />
              </Grid>
            ))}
          </Grid>
        )}
      </CardContent>
    </Card>
  );
}

export default AddonsListing;
